module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBox),
      expression: "showBox"
    }],
    staticClass: "cut_container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    ref: "overlayTop",
    staticClass: "outer-img",
    class: _vm.overlayTopClass
  }), _vm._v(" "), _c('div', {
    ref: "overlayBottom",
    staticClass: "outer-img",
    class: _vm.overlayBottomClass
  }), _vm._v(" "), _c('div', {
    ref: "overlay",
    staticClass: "overlay",
    class: _vm.overlayClass
  }, [_c('div', {
    staticClass: "overlay-inner"
  })]), _vm._v(" "), _c('div', {
    ref: "container",
    staticClass: "resize-container",
    style: ({
      top: _vm.toTop + 'px',
      left: _vm.toLeft + 'px'
    }),
    on: {
      "touchstart": _vm.startMoving,
      "touchmove": _vm.moving,
      "touchend": _vm.endMoving
    }
  }, [_c('img', {
    ref: "img",
    style: ({
      width: _vm.imgWidth,
      height: _vm.imgHeight
    }),
    attrs: {
      "id": "img",
      "src": _vm.dataUrl,
      "crossorigin": "anonymous",
      "alt": "croper"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cut_bottom"
  }, [_c('div', {
    staticClass: "btn_cancel",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "btn_crop js_crop",
    on: {
      "click": _vm.croper
    }
  }, [_vm._v("选取")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-210014c7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/headPortrait/cutImg.vue
// module id = 336
// module chunks = 0